import { journeyAction, } from './base';

import { JourneyActionVoiceVariableSet as JourneyActionVoiceVariableSetBase, } from 'atlas-shared';

export const JourneyActionVoiceVariableSet = journeyAction({
  ...JourneyActionVoiceVariableSetBase,
  icon: 'Save',
});
